import { Directive, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

// TODO: Add Angular decorator.
@Directive() 
export abstract class UnsubscribeOnDestroy implements OnDestroy {
    protected ngUnsubscribe$: Subject<any>;

    constructor () {
        this.ngUnsubscribe$ = new Subject<void>();
    }

    ngOnDestroy() {
        this.ngUnsubscribe$.next(undefined);
        this.ngUnsubscribe$.complete();

    }

}
